import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useAuthContext } from "@asgardeo/auth-react";
import Home from "../pages/Home/Home";
import GroupGuard from "../components/GroupGuard/GroupGuard";
import Benchmark from "../pages/Benchmark/Benchmark";
import Stats from "../pages/Stats/Stats";
import Results from "../pages/Results/Results";
import CaseSummary from "../pages/CaseSummary/CaseSummary";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import Privacy from "../pages/LegalPages/Privacy";
import Terms from "../pages/LegalPages/Terms";
import Refund from "../pages/LegalPages/Refund";
import Help from "../pages/Help/Help";
import About from "../pages/About/About";
import Pricing from "../pages/LegalPages/Pricing";
import Career from "../pages/Career/Career";
import Account from "../pages/Account/Account";
import CenturyCatalysts from "../pages/LegalPages/CenturyCatalysts";
import TrilingualDictionary from "../pages/Dictionary/TrilingualDictionary";

const ProtectedRoute = ({ children }) => {
  const { state, signIn } = useAuthContext();

  useEffect(() => {
    if (state.isLoading || state.isAuthenticated) {
      return;
    }

    sessionStorage.removeItem("redirectToDocument");
    sessionStorage.removeItem("urlString");
    sessionStorage.setItem(
      "redirectAfterLogin",
      `${window.location.pathname}${window.location.search}`
    );
    signIn();
  }, [signIn, state.isAuthenticated, state.isLoading]);

  if (state.isLoading || !state.isAuthenticated) {
    return null;
  }

  return children;
};

const Router = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/help" element={<Help />} />
    <Route path="/benchmark" element={<Benchmark />} />
    <Route path="/stats" element={<Stats />} />
    <Route path="/about" element={<About />} />
    <Route
      path="/search"
      element={
        <ProtectedRoute>
          <GroupGuard>
            <Results />
          </GroupGuard>
        </ProtectedRoute>
      }
    />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/refund" element={<Refund />} />
    <Route path="/terms" element={<Terms />} />
    <Route path="/pricing" element={<Pricing />} />
    <Route path="/century-pricing" element={<CenturyCatalysts />} />
    <Route path="/careers" element={<Career />} />
    <Route path="/my-account" element={<Account />} />
    <Route path="/dictionary" element={<TrilingualDictionary />} />
    <Route
      path="/summary/*"
      element={
        <ProtectedRoute>
          <CaseSummary />
        </ProtectedRoute>
      }
    />
    <Route
      path="/standard_casenumber/*"
      element={
        <ProtectedRoute>
          <CaseSummary />
        </ProtectedRoute>
      }
    />
    <Route path="*" element={<PageNotFound />} />
  </Routes>
);

export default Router;
